module.exports = __webpack_public_path__ + "img/exhibition_icon_paihang.cb6faca2.png";